import styled, { css } from "styled-components/native";

/* Generic CSS attributes that help the layout of any component. This would NOT include any color for example. */
const layoutCss = props => css`
  ${props => props.margins && `margin: ${props.margins};` }
  ${props => props.paddings && `padding: ${props.paddings};` }
  ${props => props.width && `width: ${props.width};` }
  ${props => props.height && `height: ${props.height};` }
  ${props => props.alignSelf && `align-self: ${props.alignSelf};` }
  ${props => props.flex && `flex: ${props.flex};` }
  ${props => props.backgroundColor && `background-color: ${props.backgroundColor};`}
`;

/* Generic CSS attributes that help the layout of a container. This would NOT include any color for example. */
const containerCss = props => css`
  ${props => props.flexDirection && `flex-direction: ${props.flexDirection};` }
  ${props => props.alignItems && `align-items: ${props.alignItems};` }
  ${props => props.justifyContent && `justify-content: ${props.justifyContent};` }
  ${props => props.flexWrap && `flex-wrap: ${props.flexWrap};` }
  ${props => props.flexShrink && `flex-shrink: ${props.flexShrink};` }

  ${layoutCss}
`;

/* View container that handles the layout CSS properties as props */
const Container = styled.View`
  ${containerCss}
`;

export { layoutCss, containerCss, Container };
